import { erc1155Data } from '../../contracts';

export const erc1155Abi = erc1155Data.abi;
